const simpleJsBeforeLoader = (callback) => {
  return {
    jsBeforeLoaders: [
      {
        callback
      }
    ]
  };
};
const isFunc = (fn) => typeof fn === "function";

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/F.js

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_isPlaceholder.js
function _isPlaceholder(a) {
  return a != null && typeof a === "object" && a["@@functional/placeholder"] === true;
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_curry1.js
function _curry1(fn) {
  return function f1(a) {
    if (arguments.length === 0 || _isPlaceholder(a)) {
      return f1;
    } else {
      return fn.apply(this, arguments);
    }
  };
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_curry2.js
function _curry2(fn) {
  return function f2(a, b) {
    switch (arguments.length) {
      case 0:
        return f2;
      case 1:
        return _isPlaceholder(a) ? f2 : _curry1(function(_b) {
          return fn(a, _b);
        });
      default:
        return _isPlaceholder(a) && _isPlaceholder(b) ? f2 : _isPlaceholder(a) ? _curry1(function(_a) {
          return fn(_a, b);
        }) : _isPlaceholder(b) ? _curry1(function(_b) {
          return fn(a, _b);
        }) : fn(a, b);
    }
  };
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/add.js
var add = _curry2(function add2(a, b) {
  return Number(a) + Number(b);
});
var add_default = add;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_concat.js
function _concat(set1, set22) {
  set1 = set1 || [];
  set22 = set22 || [];
  var idx;
  var len1 = set1.length;
  var len2 = set22.length;
  var result = [];
  idx = 0;
  while (idx < len1) {
    result[result.length] = set1[idx];
    idx += 1;
  }
  idx = 0;
  while (idx < len2) {
    result[result.length] = set22[idx];
    idx += 1;
  }
  return result;
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_arity.js
function _arity(n, fn) {
  switch (n) {
    case 0:
      return function() {
        return fn.apply(this, arguments);
      };
    case 1:
      return function(a0) {
        return fn.apply(this, arguments);
      };
    case 2:
      return function(a0, a1) {
        return fn.apply(this, arguments);
      };
    case 3:
      return function(a0, a1, a2) {
        return fn.apply(this, arguments);
      };
    case 4:
      return function(a0, a1, a2, a3) {
        return fn.apply(this, arguments);
      };
    case 5:
      return function(a0, a1, a2, a3, a4) {
        return fn.apply(this, arguments);
      };
    case 6:
      return function(a0, a1, a2, a3, a4, a5) {
        return fn.apply(this, arguments);
      };
    case 7:
      return function(a0, a1, a2, a3, a4, a5, a6) {
        return fn.apply(this, arguments);
      };
    case 8:
      return function(a0, a1, a2, a3, a4, a5, a6, a7) {
        return fn.apply(this, arguments);
      };
    case 9:
      return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
        return fn.apply(this, arguments);
      };
    case 10:
      return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
        return fn.apply(this, arguments);
      };
    default:
      throw new Error("First argument to _arity must be a non-negative integer no greater than ten");
  }
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_curryN.js
function _curryN(length3, received, fn) {
  return function() {
    var combined = [];
    var argsIdx = 0;
    var left = length3;
    var combinedIdx = 0;
    while (combinedIdx < received.length || argsIdx < arguments.length) {
      var result;
      if (combinedIdx < received.length && (!_isPlaceholder(received[combinedIdx]) || argsIdx >= arguments.length)) {
        result = received[combinedIdx];
      } else {
        result = arguments[argsIdx];
        argsIdx += 1;
      }
      combined[combinedIdx] = result;
      if (!_isPlaceholder(result)) {
        left -= 1;
      }
      combinedIdx += 1;
    }
    return left <= 0 ? fn.apply(this, combined) : _arity(left, _curryN(length3, combined, fn));
  };
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/curryN.js
var curryN = _curry2(function curryN2(length3, fn) {
  if (length3 === 1) {
    return _curry1(fn);
  }
  return _arity(length3, _curryN(length3, [], fn));
});
var curryN_default = curryN;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_curry3.js
function _curry3(fn) {
  return function f3(a, b, c) {
    switch (arguments.length) {
      case 0:
        return f3;
      case 1:
        return _isPlaceholder(a) ? f3 : _curry2(function(_b, _c) {
          return fn(a, _b, _c);
        });
      case 2:
        return _isPlaceholder(a) && _isPlaceholder(b) ? f3 : _isPlaceholder(a) ? _curry2(function(_a, _c) {
          return fn(_a, b, _c);
        }) : _isPlaceholder(b) ? _curry2(function(_b, _c) {
          return fn(a, _b, _c);
        }) : _curry1(function(_c) {
          return fn(a, b, _c);
        });
      default:
        return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3 : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function(_a, _b) {
          return fn(_a, _b, c);
        }) : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function(_a, _c) {
          return fn(_a, b, _c);
        }) : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function(_b, _c) {
          return fn(a, _b, _c);
        }) : _isPlaceholder(a) ? _curry1(function(_a) {
          return fn(_a, b, c);
        }) : _isPlaceholder(b) ? _curry1(function(_b) {
          return fn(a, _b, c);
        }) : _isPlaceholder(c) ? _curry1(function(_c) {
          return fn(a, b, _c);
        }) : fn(a, b, c);
    }
  };
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_isArray.js
var isArray_default = Array.isArray || function _isArray(val) {
  return val != null && val.length >= 0 && Object.prototype.toString.call(val) === "[object Array]";
};

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_isTransformer.js
function _isTransformer(obj) {
  return obj != null && typeof obj["@@transducer/step"] === "function";
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_dispatchable.js
function _dispatchable(methodNames, transducerCreator, fn) {
  return function() {
    if (arguments.length === 0) {
      return fn();
    }
    var obj = arguments[arguments.length - 1];
    if (!isArray_default(obj)) {
      var idx = 0;
      while (idx < methodNames.length) {
        if (typeof obj[methodNames[idx]] === "function") {
          return obj[methodNames[idx]].apply(obj, Array.prototype.slice.call(arguments, 0, -1));
        }
        idx += 1;
      }
      if (_isTransformer(obj)) {
        var transducer = transducerCreator.apply(null, Array.prototype.slice.call(arguments, 0, -1));
        return transducer(obj);
      }
    }
    return fn.apply(this, arguments);
  };
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_reduced.js
function _reduced(x) {
  return x && x["@@transducer/reduced"] ? x : {
    "@@transducer/value": x,
    "@@transducer/reduced": true
  };
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_xfBase.js
var xfBase_default = {
  init: function() {
    return this.xf["@@transducer/init"]();
  },
  result: function(result) {
    return this.xf["@@transducer/result"](result);
  }
};

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/max.js
var max = _curry2(function max2(a, b) {
  return b > a ? b : a;
});
var max_default = max;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_map.js
function _map(fn, functor) {
  var idx = 0;
  var len = functor.length;
  var result = Array(len);
  while (idx < len) {
    result[idx] = fn(functor[idx]);
    idx += 1;
  }
  return result;
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_isString.js
function _isString(x) {
  return Object.prototype.toString.call(x) === "[object String]";
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_isArrayLike.js
var _isArrayLike = _curry1(function isArrayLike(x) {
  if (isArray_default(x)) {
    return true;
  }
  if (!x) {
    return false;
  }
  if (typeof x !== "object") {
    return false;
  }
  if (_isString(x)) {
    return false;
  }
  if (x.length === 0) {
    return true;
  }
  if (x.length > 0) {
    return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
  }
  return false;
});
var isArrayLike_default = _isArrayLike;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_xwrap.js
var XWrap = function() {
  function XWrap2(fn) {
    this.f = fn;
  }
  XWrap2.prototype["@@transducer/init"] = function() {
    throw new Error("init not implemented on XWrap");
  };
  XWrap2.prototype["@@transducer/result"] = function(acc) {
    return acc;
  };
  XWrap2.prototype["@@transducer/step"] = function(acc, x) {
    return this.f(acc, x);
  };
  return XWrap2;
}();
function _xwrap(fn) {
  return new XWrap(fn);
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/bind.js
var bind = _curry2(function bind2(fn, thisObj) {
  return _arity(fn.length, function() {
    return fn.apply(thisObj, arguments);
  });
});
var bind_default = bind;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_reduce.js
function _arrayReduce(xf, acc, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    acc = xf["@@transducer/step"](acc, list[idx]);
    if (acc && acc["@@transducer/reduced"]) {
      acc = acc["@@transducer/value"];
      break;
    }
    idx += 1;
  }
  return xf["@@transducer/result"](acc);
}
function _iterableReduce(xf, acc, iter) {
  var step = iter.next();
  while (!step.done) {
    acc = xf["@@transducer/step"](acc, step.value);
    if (acc && acc["@@transducer/reduced"]) {
      acc = acc["@@transducer/value"];
      break;
    }
    step = iter.next();
  }
  return xf["@@transducer/result"](acc);
}
function _methodReduce(xf, acc, obj, methodName) {
  return xf["@@transducer/result"](obj[methodName](bind_default(xf["@@transducer/step"], xf), acc));
}
var symIterator = typeof Symbol !== "undefined" ? Symbol.iterator : "@@iterator";
function _reduce(fn, acc, list) {
  if (typeof fn === "function") {
    fn = _xwrap(fn);
  }
  if (isArrayLike_default(list)) {
    return _arrayReduce(fn, acc, list);
  }
  if (typeof list["fantasy-land/reduce"] === "function") {
    return _methodReduce(fn, acc, list, "fantasy-land/reduce");
  }
  if (list[symIterator] != null) {
    return _iterableReduce(fn, acc, list[symIterator]());
  }
  if (typeof list.next === "function") {
    return _iterableReduce(fn, acc, list);
  }
  if (typeof list.reduce === "function") {
    return _methodReduce(fn, acc, list, "reduce");
  }
  throw new TypeError("reduce: list must be array or iterable");
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_xmap.js
var XMap = function() {
  function XMap2(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XMap2.prototype["@@transducer/init"] = xfBase_default.init;
  XMap2.prototype["@@transducer/result"] = xfBase_default.result;
  XMap2.prototype["@@transducer/step"] = function(result, input) {
    return this.xf["@@transducer/step"](result, this.f(input));
  };
  return XMap2;
}();
var _xmap = _curry2(function _xmap2(f, xf) {
  return new XMap(f, xf);
});
var xmap_default = _xmap;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_has.js
function _has(prop3, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop3);
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_isArguments.js
var toString = Object.prototype.toString;
var _isArguments = function() {
  return toString.call(arguments) === "[object Arguments]" ? function _isArguments2(x) {
    return toString.call(x) === "[object Arguments]";
  } : function _isArguments2(x) {
    return _has("callee", x);
  };
}();
var isArguments_default = _isArguments;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/keys.js
var hasEnumBug = !{
  toString: null
}.propertyIsEnumerable("toString");
var nonEnumerableProps = ["constructor", "valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"];
var hasArgsEnumBug = function() {
  return arguments.propertyIsEnumerable("length");
}();
var contains = function contains2(list, item) {
  var idx = 0;
  while (idx < list.length) {
    if (list[idx] === item) {
      return true;
    }
    idx += 1;
  }
  return false;
};
var keys = typeof Object.keys === "function" && !hasArgsEnumBug ? _curry1(function keys2(obj) {
  return Object(obj) !== obj ? [] : Object.keys(obj);
}) : _curry1(function keys3(obj) {
  if (Object(obj) !== obj) {
    return [];
  }
  var prop3, nIdx;
  var ks = [];
  var checkArgsLength = hasArgsEnumBug && isArguments_default(obj);
  for (prop3 in obj) {
    if (_has(prop3, obj) && (!checkArgsLength || prop3 !== "length")) {
      ks[ks.length] = prop3;
    }
  }
  if (hasEnumBug) {
    nIdx = nonEnumerableProps.length - 1;
    while (nIdx >= 0) {
      prop3 = nonEnumerableProps[nIdx];
      if (_has(prop3, obj) && !contains(ks, prop3)) {
        ks[ks.length] = prop3;
      }
      nIdx -= 1;
    }
  }
  return ks;
});
var keys_default = keys;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/map.js
var map = _curry2(
  _dispatchable(["fantasy-land/map", "map"], xmap_default, function map2(fn, functor) {
    switch (Object.prototype.toString.call(functor)) {
      case "[object Function]":
        return curryN_default(functor.length, function() {
          return fn.call(this, functor.apply(this, arguments));
        });
      case "[object Object]":
        return _reduce(function(acc, key) {
          acc[key] = fn(functor[key]);
          return acc;
        }, {}, keys_default(functor));
      default:
        return _map(fn, functor);
    }
  })
);
var map_default = map;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_isInteger.js
var isInteger_default = Number.isInteger || function _isInteger(n) {
  return n << 0 === n;
};

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/nth.js
var nth = _curry2(function nth2(offset, list) {
  var idx = offset < 0 ? list.length + offset : offset;
  return _isString(list) ? list.charAt(idx) : list[idx];
});
var nth_default = nth;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/prop.js
var prop = _curry2(function prop2(p, obj) {
  if (obj == null) {
    return;
  }
  return isInteger_default(p) ? nth_default(p, obj) : obj[p];
});
var prop_default = prop;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/pluck.js
var pluck = _curry2(function pluck2(p, list) {
  return map_default(prop_default(p), list);
});
var pluck_default = pluck;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/reduce.js
var reduce = _curry3(_reduce);
var reduce_default = reduce;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/ap.js
var ap = _curry2(function ap2(applyF, applyX) {
  return typeof applyX["fantasy-land/ap"] === "function" ? applyX["fantasy-land/ap"](applyF) : typeof applyF.ap === "function" ? applyF.ap(applyX) : typeof applyF === "function" ? function(x) {
    return applyF(x)(applyX(x));
  } : _reduce(function(acc, f) {
    return _concat(acc, map_default(f, applyX));
  }, [], applyF);
});
var ap_default = ap;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_isFunction.js
function _isFunction(x) {
  var type3 = Object.prototype.toString.call(x);
  return type3 === "[object Function]" || type3 === "[object AsyncFunction]" || type3 === "[object GeneratorFunction]" || type3 === "[object AsyncGeneratorFunction]";
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/liftN.js
var liftN = _curry2(function liftN2(arity, fn) {
  var lifted = curryN_default(arity, fn);
  return curryN_default(arity, function() {
    return _reduce(ap_default, map_default(lifted, arguments[0]), Array.prototype.slice.call(arguments, 1));
  });
});
var liftN_default = liftN;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/lift.js
var lift = _curry1(function lift2(fn) {
  return liftN_default(fn.length, fn);
});
var lift_default = lift;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_makeFlat.js
function _makeFlat(recursive) {
  return function flatt(list) {
    var value, jlen, j;
    var result = [];
    var idx = 0;
    var ilen = list.length;
    while (idx < ilen) {
      if (isArrayLike_default(list[idx])) {
        value = recursive ? flatt(list[idx]) : list[idx];
        j = 0;
        jlen = value.length;
        while (j < jlen) {
          result[result.length] = value[j];
          j += 1;
        }
      } else {
        result[result.length] = list[idx];
      }
      idx += 1;
    }
    return result;
  };
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_forceReduced.js
function _forceReduced(x) {
  return {
    "@@transducer/value": x,
    "@@transducer/reduced": true
  };
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_flatCat.js
var preservingReduced = function(xf) {
  return {
    "@@transducer/init": xfBase_default.init,
    "@@transducer/result": function(result) {
      return xf["@@transducer/result"](result);
    },
    "@@transducer/step": function(result, input) {
      var ret = xf["@@transducer/step"](result, input);
      return ret["@@transducer/reduced"] ? _forceReduced(ret) : ret;
    }
  };
};
var _flatCat = function _xcat(xf) {
  var rxf = preservingReduced(xf);
  return {
    "@@transducer/init": xfBase_default.init,
    "@@transducer/result": function(result) {
      return rxf["@@transducer/result"](result);
    },
    "@@transducer/step": function(result, input) {
      return !isArrayLike_default(input) ? _reduce(rxf, result, [input]) : _reduce(rxf, result, input);
    }
  };
};
var flatCat_default = _flatCat;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_xchain.js
var _xchain = _curry2(function _xchain2(f, xf) {
  return map_default(f, flatCat_default(xf));
});
var xchain_default = _xchain;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/chain.js
var chain = _curry2(
  _dispatchable(["fantasy-land/chain", "chain"], xchain_default, function chain2(fn, monad) {
    if (typeof monad === "function") {
      return function(x) {
        return fn(monad(x))(x);
      };
    }
    return _makeFlat(false)(map_default(fn, monad));
  })
);
var chain_default = chain;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_cloneRegExp.js
function _cloneRegExp(pattern) {
  return new RegExp(pattern.source, (pattern.global ? "g" : "") + (pattern.ignoreCase ? "i" : "") + (pattern.multiline ? "m" : "") + (pattern.sticky ? "y" : "") + (pattern.unicode ? "u" : ""));
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/type.js
var type = _curry1(function type2(val) {
  return val === null ? "Null" : val === void 0 ? "Undefined" : Object.prototype.toString.call(val).slice(8, -1);
});
var type_default = type;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_clone.js
function _clone(value, refFrom, refTo, deep) {
  var copy = function copy2(copiedValue) {
    var len = refFrom.length;
    var idx = 0;
    while (idx < len) {
      if (value === refFrom[idx]) {
        return refTo[idx];
      }
      idx += 1;
    }
    refFrom[idx] = value;
    refTo[idx] = copiedValue;
    for (var key in value) {
      if (value.hasOwnProperty(key)) {
        copiedValue[key] = deep ? _clone(value[key], refFrom, refTo, true) : value[key];
      }
    }
    return copiedValue;
  };
  switch (type_default(value)) {
    case "Object":
      return copy(Object.create(Object.getPrototypeOf(value)));
    case "Array":
      return copy([]);
    case "Date":
      return new Date(value.valueOf());
    case "RegExp":
      return _cloneRegExp(value);
    case "Int8Array":
    case "Uint8Array":
    case "Uint8ClampedArray":
    case "Int16Array":
    case "Uint16Array":
    case "Int32Array":
    case "Uint32Array":
    case "Float32Array":
    case "Float64Array":
    case "BigInt64Array":
    case "BigUint64Array":
      return value.slice();
    default:
      return value;
  }
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/not.js
var not = _curry1(function not2(a) {
  return !a;
});
var not_default = not;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/complement.js
lift_default(not_default);

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_pipe.js
function _pipe(f, g) {
  return function() {
    return g.call(this, f.apply(this, arguments));
  };
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_checkForMethod.js
function _checkForMethod(methodname, fn) {
  return function() {
    var length3 = arguments.length;
    if (length3 === 0) {
      return fn();
    }
    var obj = arguments[length3 - 1];
    return isArray_default(obj) || typeof obj[methodname] !== "function" ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length3 - 1));
  };
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/slice.js
var slice = _curry3(
  _checkForMethod("slice", function slice2(fromIndex, toIndex, list) {
    return Array.prototype.slice.call(list, fromIndex, toIndex);
  })
);
var slice_default = slice;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/tail.js
var tail = _curry1(
  _checkForMethod(
    "tail",
    slice_default(1, Infinity)
  )
);
var tail_default = tail;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/pipe.js
function pipe() {
  if (arguments.length === 0) {
    throw new Error("pipe requires at least one argument");
  }
  return _arity(arguments[0].length, reduce_default(_pipe, arguments[0], tail_default(arguments)));
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/reverse.js
var reverse = _curry1(function reverse2(list) {
  return _isString(list) ? list.split("").reverse().join("") : Array.prototype.slice.call(list, 0).reverse();
});
var reverse_default = reverse;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/compose.js
function compose() {
  if (arguments.length === 0) {
    throw new Error("compose requires at least one argument");
  }
  return pipe.apply(this, reverse_default(arguments));
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/head.js
nth_default(0);

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_identity.js
function _identity(x) {
  return x;
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/identity.js
var identity = _curry1(_identity);
var identity_default = identity;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_arrayFromIterator.js
function _arrayFromIterator(iter) {
  var list = [];
  var next;
  while (!(next = iter.next()).done) {
    list.push(next.value);
  }
  return list;
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_includesWith.js
function _includesWith(pred, x, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    if (pred(x, list[idx])) {
      return true;
    }
    idx += 1;
  }
  return false;
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_functionName.js
function _functionName(f) {
  var match3 = String(f).match(/^function (\w*)/);
  return match3 == null ? "" : match3[1];
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_objectIs.js
function _objectIs(a, b) {
  if (a === b) {
    return a !== 0 || 1 / a === 1 / b;
  } else {
    return a !== a && b !== b;
  }
}
var objectIs_default = typeof Object.is === "function" ? Object.is : _objectIs;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_equals.js
function _uniqContentEquals(aIterator, bIterator, stackA, stackB) {
  var a = _arrayFromIterator(aIterator);
  var b = _arrayFromIterator(bIterator);
  function eq(_a, _b) {
    return _equals(_a, _b, stackA.slice(), stackB.slice());
  }
  return !_includesWith(function(b2, aItem) {
    return !_includesWith(eq, aItem, b2);
  }, b, a);
}
function _equals(a, b, stackA, stackB) {
  if (objectIs_default(a, b)) {
    return true;
  }
  var typeA = type_default(a);
  if (typeA !== type_default(b)) {
    return false;
  }
  if (typeof a["fantasy-land/equals"] === "function" || typeof b["fantasy-land/equals"] === "function") {
    return typeof a["fantasy-land/equals"] === "function" && a["fantasy-land/equals"](b) && typeof b["fantasy-land/equals"] === "function" && b["fantasy-land/equals"](a);
  }
  if (typeof a.equals === "function" || typeof b.equals === "function") {
    return typeof a.equals === "function" && a.equals(b) && typeof b.equals === "function" && b.equals(a);
  }
  switch (typeA) {
    case "Arguments":
    case "Array":
    case "Object":
      if (typeof a.constructor === "function" && _functionName(a.constructor) === "Promise") {
        return a === b;
      }
      break;
    case "Boolean":
    case "Number":
    case "String":
      if (!(typeof a === typeof b && objectIs_default(a.valueOf(), b.valueOf()))) {
        return false;
      }
      break;
    case "Date":
      if (!objectIs_default(a.valueOf(), b.valueOf())) {
        return false;
      }
      break;
    case "Error":
      return a.name === b.name && a.message === b.message;
    case "RegExp":
      if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) {
        return false;
      }
      break;
  }
  var idx = stackA.length - 1;
  while (idx >= 0) {
    if (stackA[idx] === a) {
      return stackB[idx] === b;
    }
    idx -= 1;
  }
  switch (typeA) {
    case "Map":
      if (a.size !== b.size) {
        return false;
      }
      return _uniqContentEquals(a.entries(), b.entries(), stackA.concat([a]), stackB.concat([b]));
    case "Set":
      if (a.size !== b.size) {
        return false;
      }
      return _uniqContentEquals(a.values(), b.values(), stackA.concat([a]), stackB.concat([b]));
    case "Arguments":
    case "Array":
    case "Object":
    case "Boolean":
    case "Number":
    case "String":
    case "Date":
    case "Error":
    case "RegExp":
    case "Int8Array":
    case "Uint8Array":
    case "Uint8ClampedArray":
    case "Int16Array":
    case "Uint16Array":
    case "Int32Array":
    case "Uint32Array":
    case "Float32Array":
    case "Float64Array":
    case "ArrayBuffer":
      break;
    default:
      return false;
  }
  var keysA = keys_default(a);
  if (keysA.length !== keys_default(b).length) {
    return false;
  }
  var extendedStackA = stackA.concat([a]);
  var extendedStackB = stackB.concat([b]);
  idx = keysA.length - 1;
  while (idx >= 0) {
    var key = keysA[idx];
    if (!(_has(key, b) && _equals(b[key], a[key], extendedStackA, extendedStackB))) {
      return false;
    }
    idx -= 1;
  }
  return true;
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/equals.js
var equals = _curry2(function equals2(a, b) {
  return _equals(a, b, [], []);
});
var equals_default = equals;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_indexOf.js
function _indexOf(list, a, idx) {
  var inf, item;
  if (typeof list.indexOf === "function") {
    switch (typeof a) {
      case "number":
        if (a === 0) {
          inf = 1 / a;
          while (idx < list.length) {
            item = list[idx];
            if (item === 0 && 1 / item === inf) {
              return idx;
            }
            idx += 1;
          }
          return -1;
        } else if (a !== a) {
          while (idx < list.length) {
            item = list[idx];
            if (typeof item === "number" && item !== item) {
              return idx;
            }
            idx += 1;
          }
          return -1;
        }
        return list.indexOf(a, idx);
      case "string":
      case "boolean":
      case "function":
      case "undefined":
        return list.indexOf(a, idx);
      case "object":
        if (a === null) {
          return list.indexOf(a, idx);
        }
    }
  }
  while (idx < list.length) {
    if (equals_default(list[idx], a)) {
      return idx;
    }
    idx += 1;
  }
  return -1;
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_includes.js
function _includes(a, list) {
  return _indexOf(list, a, 0) >= 0;
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_quote.js
function _quote(s) {
  var escaped = s.replace(/\\/g, "\\\\").replace(/[\b]/g, "\\b").replace(/\f/g, "\\f").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\t/g, "\\t").replace(/\v/g, "\\v").replace(/\0/g, "\\0");
  return '"' + escaped.replace(/"/g, '\\"') + '"';
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_toISOString.js
var pad = function pad2(n) {
  return (n < 10 ? "0" : "") + n;
};
var _toISOString = typeof Date.prototype.toISOString === "function" ? function _toISOString2(d) {
  return d.toISOString();
} : function _toISOString3(d) {
  return d.getUTCFullYear() + "-" + pad(d.getUTCMonth() + 1) + "-" + pad(d.getUTCDate()) + "T" + pad(d.getUTCHours()) + ":" + pad(d.getUTCMinutes()) + ":" + pad(d.getUTCSeconds()) + "." + (d.getUTCMilliseconds() / 1e3).toFixed(3).slice(2, 5) + "Z";
};
var toISOString_default = _toISOString;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_complement.js
function _complement(f) {
  return function() {
    return !f.apply(this, arguments);
  };
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_filter.js
function _filter(fn, list) {
  var idx = 0;
  var len = list.length;
  var result = [];
  while (idx < len) {
    if (fn(list[idx])) {
      result[result.length] = list[idx];
    }
    idx += 1;
  }
  return result;
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_isObject.js
function _isObject(x) {
  return Object.prototype.toString.call(x) === "[object Object]";
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_xfilter.js
var XFilter = function() {
  function XFilter2(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XFilter2.prototype["@@transducer/init"] = xfBase_default.init;
  XFilter2.prototype["@@transducer/result"] = xfBase_default.result;
  XFilter2.prototype["@@transducer/step"] = function(result, input) {
    return this.f(input) ? this.xf["@@transducer/step"](result, input) : result;
  };
  return XFilter2;
}();
var _xfilter = _curry2(function _xfilter2(f, xf) {
  return new XFilter(f, xf);
});
var xfilter_default = _xfilter;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/filter.js
var filter = _curry2(
  _dispatchable(["fantasy-land/filter", "filter"], xfilter_default, function(pred, filterable) {
    return _isObject(filterable) ? _reduce(function(acc, key) {
      if (pred(filterable[key])) {
        acc[key] = filterable[key];
      }
      return acc;
    }, {}, keys_default(filterable)) : _filter(pred, filterable);
  })
);
var filter_default = filter;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/reject.js
var reject = _curry2(function reject2(pred, filterable) {
  return filter_default(_complement(pred), filterable);
});
var reject_default = reject;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_toString.js
function _toString(x, seen) {
  var recur = function recur2(y) {
    var xs = seen.concat([x]);
    return _includes(y, xs) ? "<Circular>" : _toString(y, xs);
  };
  var mapPairs = function(obj, keys4) {
    return _map(function(k) {
      return _quote(k) + ": " + recur(obj[k]);
    }, keys4.slice().sort());
  };
  switch (Object.prototype.toString.call(x)) {
    case "[object Arguments]":
      return "(function() { return arguments; }(" + _map(recur, x).join(", ") + "))";
    case "[object Array]":
      return "[" + _map(recur, x).concat(mapPairs(x, reject_default(function(k) {
        return /^\d+$/.test(k);
      }, keys_default(x)))).join(", ") + "]";
    case "[object Boolean]":
      return typeof x === "object" ? "new Boolean(" + recur(x.valueOf()) + ")" : x.toString();
    case "[object Date]":
      return "new Date(" + (isNaN(x.valueOf()) ? recur(NaN) : _quote(toISOString_default(x))) + ")";
    case "[object Null]":
      return "null";
    case "[object Number]":
      return typeof x === "object" ? "new Number(" + recur(x.valueOf()) + ")" : 1 / x === -Infinity ? "-0" : x.toString(10);
    case "[object String]":
      return typeof x === "object" ? "new String(" + recur(x.valueOf()) + ")" : _quote(x);
    case "[object Undefined]":
      return "undefined";
    default:
      if (typeof x.toString === "function") {
        var repr = x.toString();
        if (repr !== "[object Object]") {
          return repr;
        }
      }
      return "{" + mapPairs(x, keys_default(x)).join(", ") + "}";
  }
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/toString.js
var toString2 = _curry1(function toString3(val) {
  return _toString(val, []);
});
var toString_default = toString2;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/curry.js
var curry = _curry1(function curry2(fn) {
  return curryN_default(fn.length, fn);
});
var curry_default = curry;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/converge.js
var converge = _curry2(function converge2(after, fns) {
  return curryN_default(reduce_default(max_default, 0, pluck_default("length", fns)), function() {
    var args = arguments;
    var context = this;
    return after.apply(context, _map(function(fn) {
      return fn.apply(context, args);
    }, fns));
  });
});
var converge_default = converge;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/count.js
curry_default(function(pred, list) {
  return _reduce(function(a, e) {
    return pred(e) ? a + 1 : a;
  }, 0, list);
});

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_xreduceBy.js
var XReduceBy = function() {
  function XReduceBy2(valueFn, valueAcc, keyFn, xf) {
    this.valueFn = valueFn;
    this.valueAcc = valueAcc;
    this.keyFn = keyFn;
    this.xf = xf;
    this.inputs = {};
  }
  XReduceBy2.prototype["@@transducer/init"] = xfBase_default.init;
  XReduceBy2.prototype["@@transducer/result"] = function(result) {
    var key;
    for (key in this.inputs) {
      if (_has(key, this.inputs)) {
        result = this.xf["@@transducer/step"](result, this.inputs[key]);
        if (result["@@transducer/reduced"]) {
          result = result["@@transducer/value"];
          break;
        }
      }
    }
    this.inputs = null;
    return this.xf["@@transducer/result"](result);
  };
  XReduceBy2.prototype["@@transducer/step"] = function(result, input) {
    var key = this.keyFn(input);
    this.inputs[key] = this.inputs[key] || [key, this.valueAcc];
    this.inputs[key][1] = this.valueFn(this.inputs[key][1], input);
    return result;
  };
  return XReduceBy2;
}();
var _xreduceBy = _curryN(4, [], function _xreduceBy2(valueFn, valueAcc, keyFn, xf) {
  return new XReduceBy(valueFn, valueAcc, keyFn, xf);
});
var xreduceBy_default = _xreduceBy;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/reduceBy.js
var reduceBy = _curryN(
  4,
  [],
  _dispatchable([], xreduceBy_default, function reduceBy2(valueFn, valueAcc, keyFn, list) {
    return _reduce(function(acc, elt) {
      var key = keyFn(elt);
      var value = valueFn(_has(key, acc) ? acc[key] : _clone(valueAcc, [], [], false), elt);
      if (value && value["@@transducer/reduced"]) {
        return _reduced(acc);
      }
      acc[key] = value;
      return acc;
    }, {}, list);
  })
);
var reduceBy_default = reduceBy;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/countBy.js
reduceBy_default(function(acc, elem) {
  return acc + 1;
}, 0);

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/dec.js
add_default(-1);

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_Set.js
var _Set = function() {
  function _Set2() {
    this._nativeSet = typeof Set === "function" ? /* @__PURE__ */ new Set() : null;
    this._items = {};
  }
  _Set2.prototype.add = function(item) {
    return !hasOrAdd(item, true, this);
  };
  _Set2.prototype.has = function(item) {
    return hasOrAdd(item, false, this);
  };
  return _Set2;
}();
function hasOrAdd(item, shouldAdd, set3) {
  var type3 = typeof item;
  var prevSize, newSize;
  switch (type3) {
    case "string":
    case "number":
      if (item === 0 && 1 / item === -Infinity) {
        if (set3._items["-0"]) {
          return true;
        } else {
          if (shouldAdd) {
            set3._items["-0"] = true;
          }
          return false;
        }
      }
      if (set3._nativeSet !== null) {
        if (shouldAdd) {
          prevSize = set3._nativeSet.size;
          set3._nativeSet.add(item);
          newSize = set3._nativeSet.size;
          return newSize === prevSize;
        } else {
          return set3._nativeSet.has(item);
        }
      } else {
        if (!(type3 in set3._items)) {
          if (shouldAdd) {
            set3._items[type3] = {};
            set3._items[type3][item] = true;
          }
          return false;
        } else if (item in set3._items[type3]) {
          return true;
        } else {
          if (shouldAdd) {
            set3._items[type3][item] = true;
          }
          return false;
        }
      }
    case "boolean":
      if (type3 in set3._items) {
        var bIdx = item ? 1 : 0;
        if (set3._items[type3][bIdx]) {
          return true;
        } else {
          if (shouldAdd) {
            set3._items[type3][bIdx] = true;
          }
          return false;
        }
      } else {
        if (shouldAdd) {
          set3._items[type3] = item ? [false, true] : [true, false];
        }
        return false;
      }
    case "function":
      if (set3._nativeSet !== null) {
        if (shouldAdd) {
          prevSize = set3._nativeSet.size;
          set3._nativeSet.add(item);
          newSize = set3._nativeSet.size;
          return newSize === prevSize;
        } else {
          return set3._nativeSet.has(item);
        }
      } else {
        if (!(type3 in set3._items)) {
          if (shouldAdd) {
            set3._items[type3] = [item];
          }
          return false;
        }
        if (!_includes(item, set3._items[type3])) {
          if (shouldAdd) {
            set3._items[type3].push(item);
          }
          return false;
        }
        return true;
      }
    case "undefined":
      if (set3._items[type3]) {
        return true;
      } else {
        if (shouldAdd) {
          set3._items[type3] = true;
        }
        return false;
      }
    case "object":
      if (item === null) {
        if (!set3._items["null"]) {
          if (shouldAdd) {
            set3._items["null"] = true;
          }
          return false;
        }
        return true;
      }
    default:
      type3 = Object.prototype.toString.call(item);
      if (!(type3 in set3._items)) {
        if (shouldAdd) {
          set3._items[type3] = [item];
        }
        return false;
      }
      if (!_includes(item, set3._items[type3])) {
        if (shouldAdd) {
          set3._items[type3].push(item);
        }
        return false;
      }
      return true;
  }
}
var Set_default = _Set;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_xdropRepeatsWith.js
var XDropRepeatsWith = function() {
  function XDropRepeatsWith2(pred, xf) {
    this.xf = xf;
    this.pred = pred;
    this.lastValue = void 0;
    this.seenFirstValue = false;
  }
  XDropRepeatsWith2.prototype["@@transducer/init"] = xfBase_default.init;
  XDropRepeatsWith2.prototype["@@transducer/result"] = xfBase_default.result;
  XDropRepeatsWith2.prototype["@@transducer/step"] = function(result, input) {
    var sameAsLast = false;
    if (!this.seenFirstValue) {
      this.seenFirstValue = true;
    } else if (this.pred(this.lastValue, input)) {
      sameAsLast = true;
    }
    this.lastValue = input;
    return sameAsLast ? result : this.xf["@@transducer/step"](result, input);
  };
  return XDropRepeatsWith2;
}();
var _xdropRepeatsWith = _curry2(function _xdropRepeatsWith2(pred, xf) {
  return new XDropRepeatsWith(pred, xf);
});
var xdropRepeatsWith_default = _xdropRepeatsWith;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/last.js
var last = nth_default(-1);
var last_default = last;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/dropRepeatsWith.js
var dropRepeatsWith = _curry2(
  _dispatchable([], xdropRepeatsWith_default, function dropRepeatsWith2(pred, list) {
    var result = [];
    var idx = 1;
    var len = list.length;
    if (len !== 0) {
      result[0] = list[0];
      while (idx < len) {
        if (!pred(last_default(result), list[idx])) {
          result[result.length] = list[idx];
        }
        idx += 1;
      }
    }
    return result;
  })
);
var dropRepeatsWith_default = dropRepeatsWith;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/dropRepeats.js
_curry1(
  _dispatchable(
    [],
    xdropRepeatsWith_default(equals_default),
    dropRepeatsWith_default(equals_default)
  )
);

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/flip.js
var flip = _curry1(function flip2(fn) {
  return curryN_default(fn.length, function(a, b) {
    var args = Array.prototype.slice.call(arguments, 0);
    args[0] = b;
    args[1] = a;
    return fn.apply(this, args);
  });
});
var flip_default = flip;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/groupBy.js
_curry2(
  _checkForMethod(
    "groupBy",
    reduceBy_default(function(acc, item) {
      acc.push(item);
      return acc;
    }, [])
  )
);

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/inc.js
add_default(1);

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/indexBy.js
reduceBy_default(function(acc, elem) {
  return elem;
}, null);

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/init.js
slice_default(0, -1);

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_xuniqBy.js
var XUniqBy = function() {
  function XUniqBy2(f, xf) {
    this.xf = xf;
    this.f = f;
    this.set = new Set_default();
  }
  XUniqBy2.prototype["@@transducer/init"] = xfBase_default.init;
  XUniqBy2.prototype["@@transducer/result"] = xfBase_default.result;
  XUniqBy2.prototype["@@transducer/step"] = function(result, input) {
    return this.set.add(this.f(input)) ? this.xf["@@transducer/step"](result, input) : result;
  };
  return XUniqBy2;
}();
var _xuniqBy = _curry2(function _xuniqBy2(f, xf) {
  return new XUniqBy(f, xf);
});
var xuniqBy_default = _xuniqBy;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/uniqBy.js
var uniqBy = _curry2(
  _dispatchable([], xuniqBy_default, function(fn, list) {
    var set3 = new Set_default();
    var result = [];
    var idx = 0;
    var appliedItem, item;
    while (idx < list.length) {
      item = list[idx];
      appliedItem = fn(item);
      if (set3.add(appliedItem)) {
        result.push(item);
      }
      idx += 1;
    }
    return result;
  })
);
var uniqBy_default = uniqBy;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/uniq.js
var uniq = uniqBy_default(identity_default);
var uniq_default = uniq;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/invoker.js
var invoker = _curry2(function invoker2(arity, method) {
  return curryN_default(arity + 1, function() {
    var target = arguments[arity];
    if (target != null && _isFunction(target[method])) {
      return target[method].apply(target, Array.prototype.slice.call(arguments, 0, arity));
    }
    throw new TypeError(toString_default(target) + ' does not have a method named "' + method + '"');
  });
});
var invoker_default = invoker;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/join.js
invoker_default(1, "join");

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/juxt.js
var juxt = _curry1(function juxt2(fns) {
  return converge_default(function() {
    return Array.prototype.slice.call(arguments, 0);
  }, fns);
});
var juxt_default = juxt;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/sum.js
reduce_default(add_default, 0);

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/multiply.js
var multiply = _curry2(function multiply2(a, b) {
  return a * b;
});
var multiply_default = multiply;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_createPartialApplicator.js
function _createPartialApplicator(concat3) {
  return _curry2(function(fn, args) {
    return _arity(Math.max(0, fn.length - args.length), function() {
      return fn.apply(this, concat3(args, arguments));
    });
  });
}

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/partialRight.js
_createPartialApplicator(
  flip_default(_concat)
);

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/partition.js
juxt_default([filter_default, reject_default]);

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/pickAll.js
var pickAll = _curry2(function pickAll2(names, obj) {
  var result = {};
  var idx = 0;
  var len = names.length;
  while (idx < len) {
    var name = names[idx];
    result[name] = obj[name];
    idx += 1;
  }
  return result;
});
var pickAll_default = pickAll;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/product.js
reduce_default(multiply_default, 1);

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/useWith.js
var useWith = _curry2(function useWith2(fn, transformers) {
  return curryN_default(transformers.length, function() {
    var args = [];
    var idx = 0;
    while (idx < transformers.length) {
      args.push(transformers[idx].call(this, arguments[idx]));
      idx += 1;
    }
    return fn.apply(this, args.concat(Array.prototype.slice.call(arguments, transformers.length)));
  });
});
var useWith_default = useWith;

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/project.js
useWith_default(_map, [pickAll_default, identity_default]);

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/split.js
invoker_default(1, "split");

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/toLower.js
invoker_default(0, "toLowerCase");

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/toUpper.js
invoker_default(0, "toUpperCase");

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/transduce.js
curryN_default(4, function transduce2(xf, fn, acc, list) {
  return _reduce(xf(typeof fn === "function" ? _xwrap(fn) : fn), acc, list);
});

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/union.js
_curry2(
  compose(uniq_default, _concat)
);

// ../../node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/unnest.js
chain_default(_identity);

const DOM_EVENTS = {
  UIEvent: "abort DOMActivate error load resize scroll select unload",
  ProgressEvent: "abort error load loadend loadstart progress progress timeout",
  Event: "abort afterprint beforeprint cached canplay canplaythrough change chargingchange chargingtimechange checking close dischargingtimechange DOMContentLoaded downloading durationchange emptied ended ended error error error error fullscreenchange fullscreenerror input invalid languagechange levelchange loadeddata loadedmetadata noupdate obsolete offline online open open orientationchange pause pointerlockchange pointerlockerror play playing ratechange readystatechange reset seeked seeking stalled submit success suspend timeupdate updateready visibilitychange volumechange waiting",
  AnimationEvent: "animationend animationiteration animationstart",
  AudioProcessingEvent: "audioprocess",
  BeforeUnloadEvent: "beforeunload",
  TimeEvent: "beginEvent endEvent repeatEvent",
  OtherEvent: "blocked complete upgradeneeded versionchange",
  FocusEvent: "blur DOMFocusIn  Unimplemented DOMFocusOut  Unimplemented focus focusin focusout",
  MouseEvent: "click contextmenu dblclick mousedown mouseenter mouseleave mousemove mouseout mouseover mouseup show",
  SensorEvent: "compassneedscalibration Unimplemented userproximity",
  OfflineAudioCompletionEvent: "complete",
  CompositionEvent: "compositionend compositionstart compositionupdate",
  ClipboardEvent: "copy cut paste",
  DeviceLightEvent: "devicelight",
  DeviceMotionEvent: "devicemotion",
  DeviceOrientationEvent: "deviceorientation",
  DeviceProximityEvent: "deviceproximity",
  MutationNameEvent: "DOMAttributeNameChanged DOMElementNameChanged",
  MutationEvent: "DOMAttrModified DOMCharacterDataModified DOMNodeInserted DOMNodeInsertedIntoDocument DOMNodeRemoved DOMNodeRemovedFromDocument DOMSubtreeModified",
  DragEvent: "drag dragend dragenter dragleave dragover dragstart drop",
  GamepadEvent: "gamepadconnected gamepaddisconnected",
  HashChangeEvent: "hashchange",
  KeyboardEvent: "keydown keypress keyup",
  MessageEvent: "message message message message",
  PageTransitionEvent: "pagehide pageshow",
  PopStateEvent: "popstate",
  StorageEvent: "storage",
  SVGEvent: "SVGAbort SVGError SVGLoad SVGResize SVGScroll SVGUnload",
  SVGZoomEvent: "SVGZoom",
  TouchEvent: "touchcancel touchend touchenter touchleave touchmove touchstart",
  TransitionEvent: "transitionend",
  WheelEvent: "wheel"
};
const HTML_ELEMENT_CONSTRUCTORS = ["HTMLAnchorElement", "HTMLAreaElement", "HTMLAudioElement", "HTMLBaseElement", "HTMLBodyElement", "HTMLBRElement", "HTMLButtonElement", "HTMLCanvasElement", "HTMLContentElement", "HTMLDataElement", "HTMLDataListElement", "HTMLDialogElement", "HTMLDivElement", "HTMLDListElement", "HTMLElement", "HTMLEmbedElement", "HTMLFieldSetElement", "HTMLFormElement", "HTMLFrameSetElement", "HTMLHeadElement", "HTMLHeadingElement", "HTMLHRElement", "HTMLHtmlElement", "HTMLIFrameElement", "HTMLImageElement", "HTMLInputElement", "HTMLLabelElement", "HTMLLegendElement", "HTMLLIElement", "HTMLLinkElement", "HTMLMapElement", "HTMLMediaElement", "HTMLMetaElement", "HTMLMeterElement", "HTMLModElement", "HTMLObjectElement", "HTMLOListElement", "HTMLOptGroupElement", "HTMLOptionElement", "HTMLOutputElement", "HTMLParagraphElement", "HTMLPictureElement", "HTMLPreElement", "HTMLProgressElement", "HTMLQuoteElement", "HTMLScriptElement", "HTMLSelectElement", "HTMLShadowElement", "HTMLSourceElement", "HTMLSpanElement", "HTMLStyleElement", "HTMLTableCaptionElement", "HTMLTableCellElement", "HTMLTableColElement", "HTMLTableElement", "HTMLTableRowElement", "HTMLTableSectionElement", "HTMLTextAreaElement", "HTMLTemplateElement", "HTMLTimeElement", "HTMLTitleElement", "HTMLTrackElement", "HTMLUListElement", "HTMLUnknownElement", "HTMLVideoElement", "HTMLDetailsElement", "HTMLDirectoryElement", "HTMLMenuElement", "HTMLSlotElement", "HTMLMarqueeElement", "HTMLFontElement", "HTMLFrameElement", "HTMLIsIndexElement", "HTMLMenuItemElement"];
const DOCUMENT_OBJECT_CONSTRUCTORS = ["AbortController", "AbortSignal", "AbstractRange", "Attr", "CDATASection", "CharacterData", "Comment", "CustomEvent", "Document", "DocumentFragment", "DocumentType", "DOMError", "DOMException", "DOMImplementation", "DOMParser", "DOMPoint", "DOMPointReadOnly", "DOMRect", "DOMTokenList", "Element", "Event", "EventTarget", "HTMLCollection", "MutationObserver", "NamedNodeMap", "Node", "NodeIterator", "NodeList", "ProcessingInstruction", "Range", "StaticRange", "Text", "TextDecoder", "TextEncoder", "TimeRanges", "TreeWalker", "XMLDocument", "Selection", "ShadowRoot"];
const UIEVENT_OBJECT_CONSTRUCTORS = ["CompositionEvent", "FocusEvent", "InputEvent", "KeyboardEvent", "MouseEvent", "MouseScrollEvent", "MutationEvent", "UIEvent", "WheelEvent"];

const DefaultInstanceofPatchList = [...HTML_ELEMENT_CONSTRUCTORS, ...UIEVENT_OBJECT_CONSTRUCTORS, ...DOCUMENT_OBJECT_CONSTRUCTORS];
const InstanceofPlugin = (config = {}) => {
  const patchList = uniq_default([...DefaultInstanceofPatchList, ...config.patchList || []]);
  return simpleJsBeforeLoader((appWindow) => {
    const global = appWindow.__WUJIE.proxy;
    const rawHasInstance = global.Object[global.Symbol.hasInstance];
    const patchInstanceof = (prop, rawHasInstance2) => {
      var _a, _b;
      const target = global[prop];
      if (!target)
        return;
      global[prop] = new Proxy(target, {
        get(target2, p, receiver) {
          if (p === global.Symbol.hasInstance) {
            return (element) => {
              if (rawHasInstance2.call(target2, element))
                return true;
              if (element instanceof global.parent[prop])
                return true;
              return false;
            };
          }
          return Reflect.get(target2, p, receiver);
        }
      });
      if ((_b = (_a = global[prop]) == null ? void 0 : _a.prototype) == null ? void 0 : _b.constructor)
        global[prop].prototype.constructor = global[prop];
    };
    patchList.forEach((prop) => patchInstanceof(prop, rawHasInstance));
  });
};

const SelectionPlugin = () => {
  return simpleJsBeforeLoader((appWindow) => {
    if (!Selection.prototype.__IS_PATCHED_IS_COLLAPSED__) {
      Object.defineProperty(Selection.prototype, "isCollapsed", {
        get() {
          return this.anchorNode === this.focusNode && this.anchorOffset === this.focusOffset;
        }
      });
      Selection.prototype.__IS_PATCHED_IS_COLLAPSED__ = true;
    }
  });
};

const isSearch = (search) => typeof search === "string" || search instanceof RegExp || typeof search === "function";
const getSearches = (search) => {
  let searches = [/\//, /\//];
  if (!Array.isArray(search))
    return searches;
  isSearch(search[0]) ? search[0] : searches[0];
  isSearch(search[1]) ? search[1] : searches[1];
  return searches;
};
const matchUrl = (fullpath, search, config) => {
  const url = new URL(fullpath, location.href);
  const path = url.pathname + url.search + url.hash;
  if (typeof search !== "function") {
    return path.replace(search, "");
  }
  return search(fullpath, config);
};
const syncLocationFromParent = (appWindow, mainWindow, config) => {
  const mainLocation = mainWindow.location;
  const appLocation = appWindow.location;
  const search = getSearches(config.search);
  const matchedMainUrl = matchUrl(mainLocation.href, search[0], {
    window: mainWindow,
    isMain: true
  });
  const matchedAppUrl = matchUrl(appLocation.href, search[1], {
    window: appWindow,
    isMain: false
  });
  console.log(matchedMainUrl);
  console.log(matchedAppUrl);
};
const LocationSyncPlugin = (config = {}) => {
  return simpleJsBeforeLoader((appWindow) => {
    syncLocationFromParent(appWindow, appWindow.parent, config);
  });
};

const LocationReloadPlugin = (config = {}) => {
  return simpleJsBeforeLoader((appWindow) => {
    const rawLocation = appWindow.__WUJIE.proxyLocation;
    appWindow.__WUJIE.proxyLocation = new Proxy(rawLocation, {
      get(target, p, receiver) {
        if (p === "reload") {
          let matched = true;
          if (typeof (config == null ? void 0 : config.match) === "function") {
            matched = !!config.match(appWindow);
          }
          if (!matched)
            return () => void 0;
          return function() {
            return appWindow.parent.location.reload();
          };
        }
        return Reflect.get(target, p, receiver);
      }
    });
  });
};

const LocationHrefPlugin = (config = {}) => {
  return simpleJsBeforeLoader((appWindow) => {
    const rawProxyLocation = appWindow.__WUJIE.proxyLocation;
    appWindow.__WUJIE.proxyLocation = new Proxy(rawProxyLocation, {
      set(target, p, newValue, receiver) {
        if (p === "href") {
          const newUrl = new URL(newValue, target.href);
          if (newUrl.origin !== target.origin) {
            window.top.location.href = newUrl.href;
            return true;
          }
        }
        return appWindow.Reflect.set(target, p, newValue, receiver);
      }
    });
  });
};

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const polyfillEventPath = (appWindow) => {
  function setupPath(e) {
    var _a;
    e.path = (_a = e.composedPath) == null ? void 0 : _a.call(e);
  }
  const rawAddEventListener = appWindow.EventTarget.prototype.addEventListener;
  const rawRemoveEventListener = appWindow.EventTarget.prototype.removeEventListener;
  function initEventListenerList(ctx, eventName) {
    ctx.__eventListeners = ctx.__eventListeners || {};
    ctx.__eventListeners[eventName] = ctx.__eventListeners[eventName] || [];
  }
  appWindow.EventTarget.prototype.addEventListener = function(...args) {
    const eventName = args[0];
    initEventListenerList(this, eventName);
    const eventListeners = this.__eventListeners[eventName];
    if (eventListeners.length === 0) {
      rawAddEventListener.apply(this, [args[0], setupPath, args[2]]);
    }
    this.__eventListeners[eventName].push(args[1]);
    return rawAddEventListener.apply(this, args);
  };
  appWindow.EventTarget.prototype.removeEventListener = function(...args) {
    const eventName = args[0];
    initEventListenerList(this, eventName);
    const eventListeners = this.__eventListeners[eventName];
    const idx = eventListeners.findIndex((fn) => fn === args[1]);
    ~idx && eventListeners.splice(idx, 1);
    if (this.__eventListeners[eventName].length === 0) {
      rawRemoveEventListener.apply(this, [args[0], setupPath, args[2]]);
    }
    return rawRemoveEventListener.apply(this, args);
  };
  function injectNativeOnPath(target) {
    const descs = appWindow.Object.getOwnPropertyDescriptors(target);
    Object.keys(DOM_EVENTS).forEach((eventName) => {
      const events = DOM_EVENTS[eventName].split(" ").filter(Boolean);
      events.forEach((event) => {
        const eventName2 = `on${event.toLowerCase()}`;
        if (descs[eventName2]) {
          const desc = descs[eventName2];
          appWindow.Object.defineProperty(target, eventName2, __spreadProps(__spreadValues({}, desc), {
            get() {
              return this[`_${eventName2}`];
            },
            set(val) {
              if (this[`_${eventName2}`]) {
                this.removeEventListener(event, this[`_${eventName2}`]);
              }
              this[`_${eventName2}`] = val;
              if (val) {
                this.addEventListener(event, val);
              }
              return void 0;
            }
          }));
        }
      });
    });
  }
  injectNativeOnPath(appWindow.HTMLElement.prototype);
};
const patchEventTarget = (appWindow) => {
  var _a;
  if (!Object.getOwnPropertyDescriptor(Event.prototype, "path")) {
    polyfillEventPath(appWindow);
  }
  if (Event.prototype.__WUJIE_POLYFILL_EVENT_TARGET_PATCHED__)
    return;
  Event.prototype.__WUJIE_POLYFILL_EVENT_TARGET_PATCHED__ = true;
  const originEventTargetGetter = (_a = Object.getOwnPropertyDescriptor(Event.prototype, "target")) == null ? void 0 : _a.get;
  Object.defineProperty(Event.prototype, "__WUJIE_POLYFILL_TARGET__", {
    get: originEventTargetGetter
  });
  const getTargetFromPath = (path, type) => {
    const shadowRoots = path.filter((dom) => dom.shadowRoot && dom.tagName !== "WUJIE-APP");
    if (shadowRoots.length > 1)
      return shadowRoots[shadowRoots.length - 1];
    return path[0];
  };
  function targetGet() {
    const that = this;
    if (that.composed && that.composedPath() && that.composedPath()[0]) {
      return getTargetFromPath(that.composedPath(), that.type);
    }
    if (that.path && that.path[0]) {
      return getTargetFromPath(that.path, that.type);
    }
    return that.__WUJIE_POLYFILL_TARGET__;
  }
  Object.defineProperty(Event.prototype, "target", {
    get: targetGet
  });
  Object.defineProperty(Event.prototype, "srcElement", {
    get: targetGet
  });
};
const EventTargetPlugin = () => {
  return simpleJsBeforeLoader((appWindow) => {
    patchEventTarget(appWindow);
  });
};

const PORXY_HANDLER_PROPERTIES = ["apply", "construct", "defineProperty", "deleteProperty", "get", "getOwnPropertyDescriptor", "getPrototypeOf", "has", "isExtensible", "ownKeys", "preventExtensions", "set", "setPrototypeOf"];

const WindowGetterPlugin = (config = {}) => {
  return simpleJsBeforeLoader((appWindow) => {
    const rawWindowProxy = appWindow.__WUJIE.proxy;
    const handler = PORXY_HANDLER_PROPERTIES.reduce((handler2, property) => {
      if (property !== "get") {
        handler2[property] = function(target, ...args) {
          return Reflect[property].apply(null, [rawWindowProxy, ...args]);
        };
      } else {
        handler2[property] = function(target, p, receiver) {
          var _a;
          if ((_a = p == null ? void 0 : p.match) == null ? void 0 : _a.call(p, /^window$|^self$/))
            return appWindow.__WUJIE.proxy;
          return Reflect.get(rawWindowProxy, p, receiver);
        };
      }
      return handler2;
    }, {});
    appWindow.__WUJIE.proxy = new Proxy({}, handler);
  });
};

const WindowMessagePlugin = () => {
  return {
    windowAddEventListenerHook(iframeWindow, type, handler, options) {
      if (type === "message") {
        window.addEventListener.call(iframeWindow, type, handler, options);
      }
    },
    windowRemoveEventListenerHook(iframeWindow, type, handler, options) {
      if (type === "message") {
        window.removeEventListener.call(iframeWindow, type, handler, options);
      }
    }
  };
};

const WindowSizePlugin = (config = {}) => {
  return simpleJsBeforeLoader((appWindow) => {
    const rawWindowProxy = appWindow.__WUJIE.proxy;
    const shadowRoot = appWindow.__WUJIE.shadowRoot;
    const getters = {
      innerHeight: () => !config.shadow ? rawWindowProxy.parent.innerHeight : shadowRoot.ownerDocument.body.getBoundingClientRect().height,
      innerWidth: () => !config.shadow ? rawWindowProxy.parent.innerWidth : shadowRoot.ownerDocument.body.getBoundingClientRect().width,
      outerWidth: () => rawWindowProxy.parent.outerWidth,
      outerHeight: () => rawWindowProxy.parent.outerHeight
    };
    const store = {};
    const desc = Object.getOwnPropertyDescriptor(appWindow, "innerHeight");
    if (desc == null ? void 0 : desc.configurable) {
      Object.keys(getters).forEach((p) => {
        Object.defineProperty(appWindow, p, {
          configurable: true,
          enumerable: true,
          get() {
            return store.hasOwnProperty(p) ? store[p] : getters[p]();
          },
          set(val) {
            store[p] = val;
          }
        });
      });
    } else {
      appWindow.__WUJIE.proxy = new Proxy(rawWindowProxy, {
        get(target, p, receiver) {
          if (getters[p]) {
            return store.hasOwnProperty(p) ? store[p] : getters[p]();
          }
          return Reflect.get(target, p, receiver);
        },
        set(target, p, val, receiver) {
          if (getters[p]) {
            store[p] = val;
            return true;
          }
          return Reflect.set(target, p, val, receiver);
        }
      });
    }
  });
};

const DocFullscreenPlugin = () => {
  return simpleJsBeforeLoader((appWindow) => {
    const requestFuncList = ["requestFullscreen", "mozRequestFullScreen", "webkitRequestFullscreen", "msRequestFullscreen"];
    const cancelFuncList = ["mozCancelFullScreen", "webkitCancelFullScreen", "msExitFullscreen"];
    const elementlist = ["fullscreenElement", "webkitFullscreenElement", "mozFullScreenElement", "msFullscreenElement"];
    const enabledList = ["fullscreenEnabled", "webkitFullscreenEnabled", "mozFullScreenEnabled", "msFullscreenEnabled"];
    const propList = [...elementlist, ...enabledList];
    const hasSetter = function(o, p) {
      const desc = appWindow.Object.getOwnPropertyDescriptor(o, p);
      return !desc || desc.set;
    };
    const mainDoc = appWindow.parent.document;
    const appDoc = appWindow.__WUJIE.proxy.document;
    const appDocElement = appDoc.documentElement;
    requestFuncList.forEach((fnName) => {
      const mainDocElement = mainDoc.documentElement;
      if (isFunc(appDocElement[fnName]) && isFunc(mainDocElement[fnName])) {
        try {
          appDocElement[fnName] = function(...args) {
            return mainDocElement[fnName](...args);
          };
        } catch (error) {
          console.warn("[wujie-polyfill]: ", `\u5B50\u5E94\u7528 ${fnName} ${error}`);
        }
      }
    });
    cancelFuncList.forEach((fnName) => {
      if (appDoc[fnName] && hasSetter(appDoc, fnName)) {
        try {
          appDoc[fnName] = function(...args) {
            return mainDoc[fnName](...args);
          };
        } catch (error) {
          console.warn("[wujie-polyfill]: ", `\u5B50\u5E94\u7528 ${fnName} ${error}`);
        }
      }
    });
    propList.forEach((prop) => {
      if (appDoc[prop] !== void 0) {
        appWindow.Object.defineProperty(appDoc, prop, {
          get() {
            return mainDoc[prop];
          }
        });
      }
    });
  });
};
const DocFullScrollPlugin = () => {
  console.warn("[wujie-polyfill]: DocFullScrollPlugin \u5C06\u88AB\u5E9F\u5F03\uFF0C\u8BF7\u4F7F\u7528 DocFullscreenPlugin\u8FDB\u884C\u66FF\u4EE3");
  return DocFullscreenPlugin();
};

const DocElementRectPlugin = () => {
  return simpleJsBeforeLoader((appWindow) => {
    var _a, _b;
    const rawWindowProxy = appWindow.__WUJIE.proxy;
    const documentElement = (_b = (_a = rawWindowProxy.parent) == null ? void 0 : _a.document) == null ? void 0 : _b.documentElement;
    const propertyList = ["clientHeight", "clientWidth", "clientTop", "clientLeft", "scrollHeight", "scrollWidth", "scrollTop", "scrollLeft", "offsetHeight", "offsetWidth", "offsetTop", "offsetLeft"];
    const getters = {
      getBoundingClientRect: () => documentElement.getBoundingClientRect()
    };
    const rawDocElement = appWindow.document.documentElement;
    const proxy = new Proxy(rawDocElement, {
      get(target, property, receiver) {
        if (typeof property === "string" && propertyList.includes(property)) {
          return documentElement[property];
        }
        if (getters.hasOwnProperty(property)) {
          return getters[property];
        }
        const value = Reflect.get(target, property);
        if (typeof value === "function") {
          return value.bind(target);
        }
        return value;
      },
      set(target, property, value, receiver) {
        if (typeof property === "string" && propertyList.includes(property)) {
          documentElement[property] = value;
          return true;
        }
        return Reflect.set(target, property, value);
      }
    });
    propertyList.concat(Object.keys(getters)).forEach((key) => {
      Object.defineProperty(rawDocElement, key, {
        configurable: true,
        get() {
          return Reflect.get(proxy, key);
        },
        set(value) {
          Reflect.set(proxy, key, value);
        }
      });
    });
  });
};

export { DocElementRectPlugin, DocFullScrollPlugin, DocFullscreenPlugin, EventTargetPlugin, InstanceofPlugin, LocationHrefPlugin, LocationReloadPlugin, LocationSyncPlugin, SelectionPlugin, WindowGetterPlugin, WindowMessagePlugin, WindowSizePlugin, getSearches, isSearch, matchUrl };
//# sourceMappingURL=index.es.js.map
